import * as React from 'react';
import defaultBackground from './assets/background.png';
import { BackgroundContext } from './context';
import { useSelector } from 'react-redux';
import { selectSuburbanRkBackground } from '../../../selectors/countryside';

export const BackgroundProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const suburbanRkBackground = useSelector(selectSuburbanRkBackground);

  const state = React.useState<string>(suburbanRkBackground || defaultBackground);

  return <BackgroundContext.Provider value={state}>{children}</BackgroundContext.Provider>;
};
